<!-- choose template -->
<ng-container
  *ngIf="showContextMenu; then tplBrowserContextMenu; else tplDefault">
</ng-container>

<!-- template / default -->
<ng-template #tplDefault>
  <ng-container *ngTemplateOutlet="tplSummaryCard"></ng-container>
</ng-template>

<!-- template / enable browser -->
<ng-template #tplBrowserContextMenu>

  <a class="a--plain"
    [routerLink]="link">

    <ng-container *ngTemplateOutlet="tplSummaryCard"></ng-container>

  </a>

</ng-template>

<!-- template / summary card -->
<ng-template #tplSummaryCard>

  <lds-card [isClickable]="isClickable" (click)="onCardClick($event)" data-testid="summary-card">
    <div class="summary-card">

      <!-- card / header -->
      <div class="summary-card__header">

        <div class="summary-card__icon"
             *ngIf="hasIcon">
          <ng-content select="summary-card-icon"></ng-content>
        </div>

        <div class="summary-card__header-content">
          <ng-content select="summary-card-header"></ng-content>
        </div>

        <div class="summary-card__flags"
             *ngIf="hasFlags">
          <ng-content select="summary-card-flags"></ng-content>
        </div>

        <div class="summary-card__actions"
             *ngIf="hasActions">
          <ng-content select="summary-card-actions"></ng-content>
        </div>

      </div>

      <!-- card / content -->
      <div class="summary-card__body"
           *ngIf="hasBody">
        <ng-content select="summary-card-body"></ng-content>
      </div>

    </div>
  </lds-card>

</ng-template>

